import Category from '@/entities/catalog-page/Category/index.js'
import EditButton from '@/entities/Admin'
import dynamic from 'next/dynamic'

const Filtration = dynamic(
    () => import('@/entities/catalog-page/Filtration/index.js'),
    {
        ssr: false,
    }
)

export const ClientCatalogPage = ({
    categoryId,
    configRequest,
    setConfigRequest,
    setMount,
}) => {
    return (
        <>
            <EditButton item={'category'} item_id={categoryId} />
            <div className={'settings-wrapper'}>
                <Category
                    currentConfig={configRequest}
                    changeConfigRequest={setConfigRequest}
                />
                <Filtration
                    setMount={setMount}
                    setConfigRequest={setConfigRequest}
                    currentConfig={configRequest}
                />
            </div>
        </>
    )
}
